export function formatHeight(heightFeet?: string, heightInches?: string): string | undefined {
    if (!heightFeet && !heightInches) {
        return undefined;
    }

    const feetPart = heightFeet ? `${heightFeet}'` : '';
    const inchesPart = heightInches ? `${heightInches}"` : '';

    return `${feetPart}${inchesPart}`;
}
